import { inview } from '../../lib/inview';

export function core(page) {

	const imgArr = document.querySelectorAll(".coreBox .right .img");
	const continuousElements = Array.from(document.getElementsByClassName('swichImg'));

	// 以前はここで毎回 resize イベントを投げていた（Waypoint の位置再計算用）。IntersectionObserver では不要
	inview(continuousElements, (direction, el) => {
		var num = el.dataset.img;

		if (direction == "down") {
			el.classList.add('active');
		} else {
			el.classList.remove('active');

			num = num - 1;
			if (num < 0) {
				num = 0;
			}
		}

		imgArr.forEach((imgArrSingle) => {
			imgArrSingle.classList.remove('active');
		});
		imgArr[num].classList.add('active');
	}, '70%');
}
